import { render } from "./takeSnapShot.vue?vue&type=template&id=3c144c4f&scoped=true"
import script from "./takeSnapShot.vue?vue&type=script&lang=js"
export * from "./takeSnapShot.vue?vue&type=script&lang=js"

import "./takeSnapShot.vue?vue&type=style&index=0&id=3c144c4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c144c4f"]])

export default __exports__